import { analytics } from '@/shared/services/analytics'
import { useWebviewStore } from '@/shared/stores/webview'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export enum OnboardingStep {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
  Five = 'five',
  Six = 'six',
  Seven = 'seven',
  Eight = 'eight',
  Nine = 'nine',
  Ten = 'ten',
  Eleven = 'eleven',
  Twelve = 'twelve',
}

export const useOnboardingStore = defineStore('onboarding', () => {
  const webviewStore = useWebviewStore()

  const maxSteps = computed(() => (webviewStore.isActive ? 11 : 12))
  const step = ref(1)
  const transition = ref<'slide-left' | 'slide-right'>('slide-left')
  const state = ref<
    Record<OnboardingStep, string | string[]> | Record<string, never>
  >({})

  const goToPrevStep = () => {
    transition.value = 'slide-right'
    step.value = Math.max(step.value - 1, 0)
  }

  const goToNextStep = (data?: { question: string; answers: string[] }) => {
    analytics.track('onboarding_step_completed', {
      step: step.value,
      source: webviewStore.isActive
        ? webviewStore.isiOS
          ? 'apple'
          : 'google'
        : 'web',
      ...(data && {
        question: data.question,
        answers: data.answers.join(', '),
      }),
    })
    transition.value = 'slide-left'
    step.value = Math.min(step.value + 1, maxSteps.value)
  }

  return {
    maxSteps,
    step,
    transition,
    goToPrevStep,
    goToNextStep,
    state,
  }
})
